import _ from 'lodash';
import {
  SET_LIST,
  UPDATE_COUNT,
  UPDATE_SETTINGS,
  SET_SUBCAT,
  FILTER_SUBCAT,
  REST_SUBCAT,
  ACTIVE_PAGE,
  SET_NAVLINK,
  SET_TEMPLATE,
  UPDATE_HEADING,
  UPDATE_SEARCH,
} from '../../Constants/List/ListTypes';

const initialState = {
  TemplateList: [],
  CategoryList: {},
  totalTemplates: 0,
  settings: {},
  SubCategoryList: [],
  activePage: 1,
  navlink: '',
  setTemplate: true,
  appHeading: '',
  search: '',
};

const ListReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_LIST:
      return {
        ...state,
        [action.payload.action]: action.payload.list,
      };

    case UPDATE_COUNT:
      return {
        ...state,
        totalTemplates: action.payload.count,
      };

    case UPDATE_SETTINGS:
      return {
        ...state,
        settings: action.payload.settings,
      };

    case SET_SUBCAT:
      if (!_.find(state.SubCategoryList, { id: action.payload.id })) {
        return {
          ...state,
          SubCategoryList: state.SubCategoryList.concat({
            list: action.payload.list,
            id: action.payload.id,
            name: action.payload.name,
            slug: action.payload.slug,
            url: action.payload.url,
          }),
        };
      }
      return state;

    case FILTER_SUBCAT:
      return {
        ...state,
        SubCategoryList: state.SubCategoryList.filter(
          (index) => index.id !== action.payload.id
        ),
      };

    case REST_SUBCAT:
      return {
        ...state,
        SubCategoryList: [],
      };

    case ACTIVE_PAGE:
      return {
        ...state,
        activePage: action.payload.page,
      };

    case SET_NAVLINK:
      return {
        ...state,
        navlink: action.payload.value,
      };

    case SET_TEMPLATE:
      return {
        ...state,
        setTemplate: action.payload.value,
      };

    case UPDATE_HEADING:
      return {
        ...state,
        appHeading: action.payload.value,
      };

    case UPDATE_SEARCH:
      return {
        ...state,
        search: action.payload.value,
      };

    default:
      return state;
  }
};

export default ListReducer;
